import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { updateOrder, getOrder } from '../Services/api';
import { useTranslation } from 'react-i18next';
import './AddOrderScreen.css';
const models = [
    { id: 'K10T', image: '../res/svg/maquinas/K10T.svg' },
    { id: 'K10', image: '../res/svg/maquinas/K10.svg' },
    { id: 'K9T', image: '../res/svg/maquinas/K9T.svg' },
    { id: 'K9', image: '../res/svg/maquinas/K9.svg' },
    { id: 'K7', image: '../res/svg/maquinas/K8.svg' },
    { id: 'K8', image: '../res/svg/maquinas/K8.svg' },
    { id: 'K6', image: '../res/svg/maquinas/K6.svg' },
];

const EditOrderScreen = () => {
    const { t } = useTranslation();
    const { orderId } = useParams();
    const location = useLocation();
    const [orderData, setOrderData] = useState(location.state?.contact || {});
    const navigate = useNavigate();

    useEffect(() => {
        if (!orderData && orderId) {
            const fetchOrder = async () => {
                const token = localStorage.getItem('token');
                try {
                    const response = await getOrder(token);
                    const order = response.contacts.find(contact => contact.contactoId === orderId);
                    setOrderData(order);
                } catch (error) {
                    console.error('Error fetching order:', error);
                }
            };
            fetchOrder();
        }
    }, [orderId, orderData]);

    const handleSaveChanges = async (event) => {
        event.preventDefault();
        const token = localStorage.getItem('token');
        console.log('orderData:', orderData);
        try {
            await updateOrder(orderId, orderData, token);
            navigate('/main', { replace: true });
        } catch (error) {
            console.error('Error updating order:', error);
        }
    };

    const handleClose = () => {
        navigate('/main');
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toISOString().split('T')[0];
    };

    if (!orderData) return <div>Loading...</div>;

    return (
        <>
            <div className='add-order-screen'>
                <div className='header'>
                    <h1>{t('editOrder')}</h1>
                    <button className='close-button' onClick={handleClose}>
                        <img src='./res/svg/close_icon.svg'></img>
                    </button>
                </div>
                <div className='hdivider' />
                <form className='add-order-form' onSubmit={handleSaveChanges}>
                    <div className='form-container'>
                        <div className='form-section'>
                            <h2>{t('customerData')}</h2>
                            <label>{t('fecha')}</label>
                            <input type='date' value={formatDate(orderData.createdAt)} onChange={(e) => setOrderData({ ...orderData, createdAt: e.target.value })} required disabled />
                            <label>{t('cliente')}</label>
                            <input type='text' value={orderData.cliente} onChange={(e) => setOrderData({ ...orderData, cliente: e.target.value })} required />
                            <label>{t('direccion')}</label>
                            <input type='text' value={orderData.direccion} onChange={(e) => setOrderData({ ...orderData, direccion: e.target.value })} />
                            <label>{t('codPostal')}</label>
                            <input type='text' value={orderData.codPostal} onChange={(e) => setOrderData({ ...orderData, codPostal: e.target.value })}  />
                            <label>{t('poblacion')}</label>
                            <input type='text' value={orderData.poblacion} onChange={(e) => setOrderData({ ...orderData, poblacion: e.target.value })}  />
                            <label>{t('provincia')}</label>
                            <input type='text' value={orderData.provincia} onChange={(e) => setOrderData({ ...orderData, provincia: e.target.value })}  />
                            <label>{t('pais')}</label>
                            <input type='text' value={orderData.pais} onChange={(e) => setOrderData({ ...orderData, pais: e.target.value })}  />
                            <label>{t('telefono')}</label>
                            <input type='text' value={orderData.telefono} onChange={(e) => setOrderData({ ...orderData, telefono: e.target.value })} required />
                            <label>{t('email')}</label>
                            <input type='email' value={orderData.email} onChange={(e) => setOrderData({ ...orderData, email: e.target.value })}  />
                        </div>
                        <div className='form-section'>
                            <h2>{t('machineData')}</h2>
                            <label>{t('modelo')}</label>
                            <div className='model-selection'>
                                {models.map((model) => (
                                    <div
                                        key={model.id}
                                        className={`model-card ${orderData.modelo === model.id ? 'selected' : ''}`}
                                        onClick={() => setOrderData({ ...orderData, modelo: model.id })}
                                    >
                                        <img src={model.image} alt={model.id} />
                                        <p>{model.id}</p>
                                    </div>
                                ))}
                            </div>
                            <label>{t('observaciones')}</label>
                            <textarea value={orderData.observaciones} onChange={(e) => setOrderData({ ...orderData, observaciones: e.target.value })} />
                            <label>{t('condiciones')}</label>
                            <textarea value={orderData.condiciones} onChange={(e) => setOrderData({ ...orderData, condiciones: e.target.value })} />
                        </div>
                    </div>

                    <div className='submit-button-container'>
                        <button type='submit'>{t('saveChangesButton')}</button>
                    </div>
                </form>
            </div>
        </>
    );
};

export default EditOrderScreen;
